import * as types from "../mutation-types";
import {resetStoreState} from "@/store/storeUtils";

const defaultState = {
    upTableData: [],
    upTabType: "upload",
    pafList: [],
    activePdf: {},
    debtorData: null,
    contactData: null,
    tableItemDetail: {}
};

const state = {
    ...defaultState
};

const getters = {
    upTableData: state => state.upTableData,
    upTabType: state => state.upTabType,
    pafList: state => state.pafList,
    activePdf: state => state.activePdf,
    debtorData: state => state.debtorData,
    contactData: state => state.contactData,
    tableItemDetail: state => state.tableItemDetail,
};

const actions = {
    setActionTableItemDetail({
        commit
    }, payload) {
        commit(types.SET_ITEM_DETAIL, payload);
    },

    setActionDebtorData({
        commit
    }, payload) {
        commit(types.SET_SELECT_DEBTOR, payload);
    },
    setActionContactData({
        commit
    }, payload) {
        commit(types.SET_SELECT_CONTACT, payload);
    },
    setActionUpTableData({
        commit
    }, payload) {
        commit(types.UP_LOAD_TABLE_DATA, payload);
    },
    setActionUpLoadTab({
        commit
    }, payload) {
        commit(types.UP_LOAD_TAB_TYPE, payload);
    },
    setActionPdfList({
        commit
    }, payload) {
        commit(types.SET_PDF_LIST, payload);
    },
    setActionActivePdf({
        commit
    }, payload) {
        commit(types.SET_PDF_DATA, payload);
    }
};

const mutations = {
    [types.SET_ITEM_DETAIL](state, payload) {
        if (payload) {
            state.tableItemDetail = payload;
            state.contactData = payload.contact;
            state.debtorData = payload.obligor;
        } else {
            state.tableItemDetail = {};
            state.contactData = null;
            state.debtorData = null
        }

    },
    [types.SET_SELECT_DEBTOR](state, payload) {
        state.debtorData = payload;
    },
    [types.SET_SELECT_CONTACT](state, payload) {
        state.contactData = payload;
    },
    [types.SET_PDF_DATA](state, payload) {

        state.activePdf = payload;
    },
    [types.UP_LOAD_TABLE_DATA](state, payload) {
        state.upTableData = payload.data;
    },
    [types.UP_LOAD_TAB_TYPE](state, payload) {
        state.upTabType = payload;
    },
    [types.SET_PDF_LIST](state, payload) {
        if (payload && payload.length > 0) {
            payload = payload.map(item => {
                if (!item.receivableId) {
                    item.invoiceDocumentFileId = item.invoiceDocument;
                    item.receivableId = item.id;
                }
                return item
            })
        }
        state.pafList = payload;
    },
    initSellerState(state) {
        resetStoreState(state, defaultState);
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};